export const Footer = () => (
  <footer className="flex flex-col items-center gap-[22px] text-xs w-[390px] mt-auto pb-6 pt-24 text-on-surface-muted">
    <div className="leading-5 text-center">
      By proceeding you acknowledge that you have read, understood and agree to
      our{" "}
      <a
        href="https://www.porchpass.com/terms"
        className="underline text-inherit"
      >
        Terms and Conditions
      </a>
      .
    </div>
    <div className="flex flex-row gap-6 justify-between">
      <a
        href="https://www.porchpass.com/privacy"
        className="underline text-inherit"
      >
        Privacy
      </a>
      <a
        href="https://www.porchpass.com/contact"
        className="underline text-inherit"
      >
        Support
      </a>
      <span>© 2025 PorchPass Inc.</span>
    </div>
  </footer>
);
